{
  "category": {
    "category": "Kategorie",
    "createdNewCategory": "neue Kategorie erstellen",
    "description": "Beschreibung",
    "shortDescription": "Kurze Beschreibung",
    "name": "Name",
    "manageCategories": "Kategorien verwalten",
    "deleteCategory": "Kategorie löschen",
    "createAnother": "Erstellen Sie eine weitere Kategorie",
    "deleteAlert": "Sind Sie sicher, dass Sie diese Kategorie löschen möchten?",
    "deleteMoveTarget": "Wählen Sie eine Kategorie aus, in die Sie die Fragen verschieben möchten",
    "noCategory": "Keine Kategorie"
  },
  "datatable": {
    "rowsPerPage": "Reihen pro Seite"
  },
  "department": {
    "addDepartment": "Abteilung hinzufügen",
    "createNewDepartment": "Neue Abteilung erstellen",
    "departmentAdmin": "Admin der Abteilun",
    "departmentName": "Name der Abteilung",
    "edit": "bearbeiten",
    "institution": "Einrichtung",
    "institutionName": "Name der Einrichtung",
    "searchDepartments": "Abteilung(en) suchen",
    "thisFieldIsRequired": "Dieses Feld ist notwendig"
  },
  "form": {
    "canNotEndBeforeParentStarts": "Kann nicht beenden, bevor Eltern starten",
    "canNotEndBeforeStart": "Kann nicht vor dem Start enden",
    "canNotEndWhenParentEnded": "Kann nicht enden wenn Eltern beenden",
    "canNotStartAfterEnd": "Cann nicht nach dem Ende sarten",
    "canNotStartBeforeParentStarts": "Kann nicht starten, bevor Eltern starten",
    "canNotStartWhenParentEnded": "Kann nicht starten, wenn Eltern beenden",
    "thisFieldIsRequired": "Dieses Feld wird benötigt"
  },
  "general": {
    "accessDenied": "Zugriff verweigert",
    "add": "hinzufügen",
    "back": "zurück",
    "cancel": "abbrechen",
    "close": "schließen",
    "dateAdded": "hinzugefügtes Datum",
    "dateUpdated": "Datum aktualisiert",
    "delete": "Löschen",
    "edit": "bearbeiten",
    "endDate": "Enddatum",
    "loading": "Läd ...",
    "name": "Name",
    "no": "Nein",
    "noData": "keine Daten",
    "ok": "Ok",
    "remove": "entfernen",
    "save": "speichern",
    "selectAll": "alles auswählen",
    "startDate": "Startdatum",
    "yes": "Ja",
    "categories": "Kategorien",
    "manage": "Verwalten",
    "saved": "Gespeichert",
    "updated": "Aktualisiert",
    "deleted": "Gelöscht",
    "selectGender": "Geschlecht auswählen",
    "gender": {
      "male": "Männlich",
      "female": "Weiblich"
    }
  },
  "institution": {
    "contact": "Kontakt",
    "createNewInstitution": "Neue Einrichtung erstellen",
    "name": "Name",
    "region": "Region",
    "searchInstitutions": "Einrichtung(en) auswählen",
    "switch": "wechseln",
    "switchedTo": "Einrichtung wechseln zu ",
    "unableToSwitch": "wechseln nicht möglich"
  },
  "menu": {
    "departments": "Abteilung",
    "home": "Startseite",
    "institutions": "Einrichtungen",
    "procedure": "Prozess",
    "procedures": "Prozesse",
    "reinviteusers": "erneut eingeladene Anwender",
    "scheduling": "Terminierung",
    "study": "Studie",
    "survey": "Umfrage",
    "users": "Anwender"
  },
  "procedure": {
    "addNewCategory": "neue Kategorie hinzufügen",
    "allSteps": "alle Schritte",
    "authors": "Autor",
    "category": "Kategorie",
    "createNewStep": "neuen Schritt erstellen",
    "defineFeedback": "Feedback geben",
    "department": "Abteilung",
    "description": "Beschreibungen",
    "disableProcedure": "deaktivierter Prozess",
    "addProceduresInformation": "Prozessinformationen hinzufügen",
    "editProceduresInformation": "Prozessinformationen bearbeiten",
    "duplicateStartEndStepWarning": "Es ist nur 1 Start- und 1 Endschritt erlaubt",
    "information": "Informationen",
    "institution": "Einrichtung",
    "language": "Sprache",
    "languagesAvailable": "verfügbare Sprachen",
    "media": "Medien",
    "name": "Name",
    "owner": "Besitzer",
    "procedureCategory": "Prozesskategorie",
    "procedureLanguage": "Sprache des Prozesses",
    "procedureName": "Name des Prozesses",
    "procedureNotFound": "Prozess nicht gefunden",
    "public": "öffentlich",
    "publicPrivate": "öffentlich/privat",
    "revisionHistory": "Änderungsverlauf",
    "searchSteps": "Schritt(e) durchsuchen",
    "seeFeedback": "Feedback ansehen",
    "statistics": "Statistiken",
    "step": "Schritt",
    "unableToLoad": "Prozess kann nicht geladen werden",
    "viewAs": "Ansicht als"
  },
  "procedures": {
    "addProcedure": "Prozess hinzufügen",
    "category": "Kategorie",
    "deleteProcedure": "Prozess löschen",
    "department": "Abteilung",
    "filter": "filtern",
    "private": "privat",
    "procedures": "Prozesse",
    "public": "öffentlich",
    "publicPrivate": "öffentlich/privat",
    "searchProcedures": "Prozesse durchsuchen",
    "sort": "sortieren"
  },
  "question": {
    "added": "Neue Frage erstellen",
    "answers": "Antworten",
    "cognitionName": "Bezeichnung der Wahrnehmung",
    "cognitionType": "Typ der Wahrnehmung",
    "details": "Details",
    "meaning": "Bedeutung",
    "name": "Name",
    "options": "Optionen",
    "position": "Position",
    "question": "Frage",
    "questionType": "Fragentyp",
    "set": "einstellen",
    "type": "Typ",
    "category": "Kategorie",
    "types": {
      "CHOICE": "Auswahl",
      "COGNITION": "Wahrnehmung",
      "SCALE": "Skala"
    },
    "value": "Wert",
    "editQuestion": "Frage bearbeiten",
    "deleteQuestion": "Frage löschen"
  },
  "step": {
    "addDescription": "Beschreibung hinzufügen",
    "addParentStep": "übergeordneten Schritt hinzufügen",
    "chooseParentSep": "übergeordneten Schritt auswählen",
    "chooseStepOption": "Schrittoptionen auswählen",
    "chooseTransitionType": "Typ der Überleitung auswählen",
    "chooseType": "Typ auswählen",
    "description": "Beschreibung",
    "dropFilesOrClickToUpload": "Datei ablegen oder klicken, um sie hochzuladen",
    "editStep": "Schritt bearbeiten",
    "insertMaxValue": "Maximalwert einfügen",
    "insertMinValue": "Minimalwert einfügen",
    "insertOption": "Option einfügen",
    "option": "Option",
    "owner": "Besitzer",
    "parentStep": "übergeordneter Schritt",
    "previousStep": "vorheriger Schritt",
    "saveMedia": "Medien sichern",
    "stepMedia": "Schritt Medien",
    "transitionToNextStep": "Übergang zum nächsten Schritt",
    "transitionType": "Typ der Überleitung",
    "type": "Typ",
    "value": "Wert",
    "viewInProcedure": "Prozess ansehen",
    "error": {
      "WONT_REACH_END": "Kein Pfad zum ENDE",
      "EXIT_NOT_IN_USE": "Unbenutzter Ausgang",
      "NO_PARENT_SET": "Hat keinen vorherigen Schritt",
      "PARENT_NOT_EXITS": "Definierter übergeordneter Schritt existiert nicht",
      "DUPLICATE_START": "Eine Prozedur kann nur einen START-Schritt haben",
      "DUPLICATE_END": "Eine Prozedur kann nur einen ENDE-Schritt haben"
    }
  },
  "study": {
    "addStudy": "Neue Studie erstellen",
    "author": "Autor",
    "createdNewStudy": "Neue Studie erstellen",
    "department": "Abteilung",
    "description": "Beschreibung",
    "duration": "Dauer",
    "endDate": "Enddatum",
    "name": "Name",
    "owner": "Besitzer",
    "permission": {
      "department": "Abteilung",
      "institution": "Einrichtung",
      "public": "öffentlich"
    },
    "searchStudy": "Studie suchen",
    "startDate": "Startdatum",
    "status": "Status",
    "studyName": "Name der Studie",
    "visibility": "Ansicht"
  },
  "survey": {
    "addAssessmentPeriod": "Neuen Teilzeitraum erstellen",
    "added": "Neue Studie erstellen",
    "addNew": "Neues hinzufügen",
    "addPeriod": "Neuen Zeitraum hinzufügen",
    "addSurveyPeriod": "Neue Studienzeit erstellen",
    "allAssessmentPeriods": "Alle Bewertungszeiträume",
    "ASSESSMENT_PERIOD": "BEWERTUNGSZEITRAUM",
    "author": "Autor",
    "completePreviousPeriods": "Muss der Studienteilnehmer eine vorherige Phase absolvieren, um diese Phase zu erreichen?",
    "createNewPeriod": "Neuen Zeitraum erstellen",
    "createNewQuestion": "Frage hinzufügen",
    "createNewSurvey": "Neue Studie erstellen",
    "duration": "Dauer",
    "endDate": "Enddatum",
    "key": "Schlüssel",
    "name": "Name",
    "NONE": "KEINE",
    "period": "Zeitraum",
    "periodName": "Name",
    "position": "Position",
    "question": "Frage",
    "questionList": "Fragen",
    "startDate": "Startdatum",
    "SURVEY_PERIOD": "STUDIENZEITRAUM",
    "type": "Typ",
    "surveyHasOverallScore": "Gibt es für die Umfrage eine Gesamtbewertung?",
    "howScoreCalculated": "Wie wird die Gesamtpunktzahl berechnet?",
    "surveyHasCategoryScore": "Gibt es für die Umfrage eine kategoriespezifische Bewertung?",
    "sumAnswers": "Summe aller Antworten",
    "avgAnswers": "Durchschnitt aller Antworten",
    "basicInformation": "Grundlegende Informationen",
    "surveyScore": "Umfrage-Punktzahl",
    "selectOption": "Option auswählen",
    "selectSurvey": "Umfrage auswählen",
    "jobEngagement": "Arbeitsengagement",
    "burnoutScores": "Burnout-Punktzahl",
    "viewScores": "Punktzahl ansehen",
    "hasOverallScore": "Die Umfrage hat eine Gesamtpunktzahl",
    "hasNoOverallScore": "Die Umfrage hat keine Gesamtpunktzahl",
    "noChartData": "Keine Daten für die ausgewählte Umfrage verfügbar",
    "selectChartType": "Diagrammtyp auswählen",
    "surveyCategoryInfo": "Die Umfrage verfügt über Kategorien zum Organisieren von Fragen. In diesem Abschnitt haben Sie die Möglichkeit, sie zu ändern und zu überwachen."
  },
  "user": {
    "accountSettings": "Kontoeinstellungen",
    "chooseUserRole": "Benutzerrolle auswählen",
    "contact": "Kontakt",
    "contactInformation": "Kontaktinformationen",
    "dateOfBirth": "Geburtsdatum",
    "department": "Abteilung",
    "emails": "E-Mails",
    "emailsDescription": "Fügen Sie eine oder mehrere E-Mails, getrennt durch einen Strichpunkt (Semicolon)ein. Einladungen zur Registrierung werden per Mail an die Benutzer versendet.",
    "filter": "Filter",
    "gender": "Geschlecht",
    "institution": "Einrichtung",
    "institutionalAdmin": "Admin der Einrichtung",
    "institutionAndDepartment": "Einrichtung und Abteilung ",
    "inviteUsers": "Benutzer einladen",
    "logOut": "Log-out",
    "nurse": "Krankenpfleger/in",
    "password": "Passwort",
    "patient": "Patient",
    "reInviteUsers": "Benutzer erneut einladen",
    "resetPassword": "Passwort zurücksetzen",
    "resetRequestSentTo": "Anfrage zum Zurücksetzen gesendet an",
    "searchUsers": "Benutzer suchen",
    "sendResetPasswordEmailTo": "E-mail zum zurücksetzen des Passwortes senden an",
    "sort": "sortieren",
    "subscription": "Abonnement",
    "thisFieldIsRequired": "Dieses Feld wird benötigt",
    "user": "Benutzer",
    "userDetailsUpdated": "Aktualisierung der Benutzerdetails",
    "userInformation": "Benutzerinformationen",
    "userRole": "Benutzerrolle"
  },
  "approvalRequest": {
    "actionType": "Action Type",
    "requestedBy": "Requested By",
    "approvedBy": "Approved By",
    "confirms": {
      "approveTitle": "Approve request",
      "approveText": "Are you sure you want to approve this request?",
      "rejectTitle": "Reject request",
      "rejectText": "Please provide a reason for rejecting this request.",
      "rejectReasonPlaceholder": "Rejection reason"
    },
    "actionTypes": {
      "PERMISSION_GRANT": "Permission Grant",
      "PERMISSION_REVOKE": "Permission Revoke",
      "EXPORT_VISITS": "Export Visits",
      "EXPORT_LOCATION_HISTORY": "Export Location History",
      "EXPORT_ARRIVAL_HISTORY": "Export Arrival History",
      "ENABLE_USER": "Enable User",
      "DISABLE_USER": "Disable User"
    },
    "toasts": {
      "created": "Approval request created",
      "applied": "Action applied",
      "applyFailed": "Failed to apply action",
      "approved": "Request approved",
      "approveFailed": "Failed to approve request",
      "rejected": "Request rejected",
      "rejectFailed": "Failed to reject request"
    }
  }
}
